import { updateDeleteIconActiveState } from "@src/reducers/your-reducer";
import store from "@src/reducers/store";
import { getInitialStructureNodeset } from "../dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "../dependency-injection-container/get-machine-structure-nodeset";
import { getLogger } from "../dependency-injection-container/get-logger";

export const updateInitialListAndFilteredInitialListWithSelectedNode = (
  node,
) => {
  const logger = getLogger();
  const t0 = performance.now();
  logger.debug("t0 - start of action", t0);

  const initalStructureNodeset = getInitialStructureNodeset();

  node.selected = !node.selected;

  if (node.selected) {
    initalStructureNodeset.selectedNodeIds.add(node.id);
  } else {
    initalStructureNodeset.selectedNodeIds.delete(node.id);
  }

  // This triggers the observer in the initialStructureNodeset
  initalStructureNodeset.setFilteredFlatMap(
    initalStructureNodeset.getFilteredFlatMap(),
  );

  const t1 = performance.now();
  logger.debug("t1 - end of action", t1);
  logger.debug(
    `Action to to select node with new structure took ${t1 - t0} milliseconds.`,
  );
};

export const countCheckedNodes = (item) => {
  let count = 0;

  if (item.selected) {
    count += 1;
  }

  if (item.children) {
    item.children.forEach((child) => {
      count += countCheckedNodes(child);
    });
  }

  return count;
};

const getTransferedAndTransferedFilteredCheckedNodes = () => {
  const transferedData =
    store.getState().yourSlice.editStructurePageTransferData;
  const filteredTransferedData =
    store.getState().yourSlice.editStructurePageTransferDataFiltered;

  let countTransferredNodesChecked = 0;
  if (transferedData) {
    countTransferredNodesChecked = countCheckedNodes(
      transferedData.nodeset.root_node,
    );
  }

  let countTransferredNodesFilteredChecked = 0;
  if (filteredTransferedData) {
    countTransferredNodesFilteredChecked = countCheckedNodes(
      filteredTransferedData.nodeset.root_node,
    );
  }

  return { countTransferredNodesChecked, countTransferredNodesFilteredChecked };
};

export const updateDeleteIconState = () => {
  const { countTransferredNodesChecked, countTransferredNodesFilteredChecked } =
    getTransferedAndTransferedFilteredCheckedNodes();

  if (
    countTransferredNodesChecked > 0 ||
    countTransferredNodesFilteredChecked > 0
  ) {
    store.dispatch(updateDeleteIconActiveState(true));
  } else {
    store.dispatch(updateDeleteIconActiveState(false));
  }
};

export const updateMachineStructureListAndFilteredMachineStructureListWithSelectedNode =
  (node) => {
    const logger = getLogger();

    const t0 = performance.now();
    logger.debug("t0 - start of action", t0);
    const machineStructureNodeset = getMachineStructureNodeset();

    node.selected = !node.selected;

    if (node.selected) {
      machineStructureNodeset.selectedNodeIds.add(node.id);
    } else {
      machineStructureNodeset.selectedNodeIds.delete(node.id);
    }

    // This triggers the observer in the machineStructureNodeset

    machineStructureNodeset.setFilteredFlatMap(
      machineStructureNodeset.getFilteredFlatMap(),
    );

    const t1 = performance.now();
    logger.debug("t1 - end of action", t1);
    logger.debug(
      `Action to to select node with new structure took ${
        t1 - t0
      } milliseconds.`,
    );
  };
